import Model from "flarum/Model";

export default class U2DiUserInfo extends Model {}
Object.assign(U2DiUserInfo.prototype, {
  id: Model.attribute("id"),
  totalInfoCount: Model.attribute("totalInfoCount"),
  totalInfoTDWZCount: Model.attribute("totalInfoTDWZCount"),
  totalInfoTDWZSum: Model.attribute("totalInfoTDWZSum"),
  totalInfoTDWZCompletedCount: Model.attribute("totalInfoTDWZCompletedCount"),
  totalInfoTDWZCompletedSum: Model.attribute("totalInfoTDWZCompletedSum"),
  totalInfoJZWZCount: Model.attribute("totalInfoJZWZCount"),
  totalInfoJZWZSum: Model.attribute("totalInfoJZWZSum"),
  totalInfoJZWZCompletedCount: Model.attribute("totalInfoJZWZCompletedCount"),
  totalInfoJZWZCompletedSum: Model.attribute("totalInfoJZWZCompletedSum"),
  totalQueryCount: Model.attribute("totalQueryCount"),
  totalQueryProcessingCount: Model.attribute("totalQueryProcessingCount"),
  totalQueryCompletedCount: Model.attribute("totalQueryCompletedCount"),
  totalUserCount: Model.attribute("totalUserCount"),
  totalUserNormalCount: Model.attribute("totalUserNormalCount"),
  totalUserExpiredCount: Model.attribute("totalUserExpiredCount"),
  totalUserNoExpirationCount: Model.attribute("totalUserNoExpirationCount"),
  totalUserThreeMonthExpireCount: Model.attribute("totalUserThreeMonthExpireCount"),
  totalUserThreeMonthExtendCount: Model.attribute("totalUserThreeMonthExtendCount"),
  totalUserBannedCount: Model.attribute("totalUserBannedCount"),
  totalViewsCount: Model.attribute("totalViewsCount"),
  totalAnnouncementCount: Model.attribute("totalAnnouncementCount"),
  totalDistributeCount: Model.attribute("totalDistributeCount"),
  totalDistributePerInfo: Model.attribute("totalDistributePerInfo"),
  totalViewPerInfo: Model.attribute("totalViewPerInfo"),
});